import { useSuspenseQuery } from "@tanstack/react-query"
import { Chart, type ChartProps } from "@/components/Chart"
import { CDN_COLORS } from "@/helpers/charts"
import { useCdnList } from "@/queries/cdn"

const OTHER_CDN_NAME = "Other CDN"

const ChartCdn = ({ series, options, className }: ChartProps) => {
  const { data: cdnList } = useSuspenseQuery({
    ...useCdnList(),
    refetchInterval: 10_000,
    select: d => d.results
  })

  const seriesWithWarnings = series
    .map(serie => {
      const cdn = cdnList?.find(cdn => cdn.name === serie.name)

      if (!cdn) return { ...serie }

      return {
        ...serie,
        qoeWarning: cdn.qoeStatus === "WARNING"
      }
    })
    .sort((a, b) => {
      const aName = a?.name ?? ""
      const bName = b?.name ?? ""

      if (aName === OTHER_CDN_NAME && bName !== OTHER_CDN_NAME) return 1
      if (bName === OTHER_CDN_NAME && aName !== OTHER_CDN_NAME) return -1

      return aName.localeCompare(bName)
    })
    .map((serie, index) => ({
      ...serie,
      color: CDN_COLORS[index % CDN_COLORS.length]
    }))

  return <Chart className={className} options={options} series={seriesWithWarnings} />
}

export default ChartCdn
